import { createSelector } from 'reselect';

export const getWorkspace = (state) => state.workspace;

export const findIntegration = createSelector(
    getWorkspace,
    (workspace, type) => workspace.integrations.find((i) => i.type === type)
);

export const getTeamMembers = createSelector(
    getWorkspace,
    (workspace) => workspace.team.filter((i) => i.kind === 'Member').map((i) => i.user)
);

export const findMessenger = createSelector(
    getWorkspace,
    (workspace, platform) => workspace.card.messengers.find((i) => i.messenger === platform)
);
